module.exports = __webpack_public_path__ + "img/title.35732966.png";